import FilerobotImageEditor from "filerobot-image-editor"
import React, { useEffect, useRef, useState } from "react"
import { Button, Input, InputGroup, InputGroupAddon } from "reactstrap"
import { getFileBytes } from "../utils/index"
import { InputError } from "./RenderInput"

function FileListItems(files) {
  var b = new ClipboardEvent("").clipboardData || new DataTransfer()
  for (var i = 0, len = files.length; i < len; i++) b.items.add(files[i])
  return b.files
}

const ImageEditor = ({
  input,
  label,
  meta: { touched, error },
  disabled,
  onDelete,
}) => {
  const fileInput = useRef()
  const [originalImage, setOriginalImage] = useState()
  const [shouldRenderRemove, setShouldRenderRemove] = useState(
    fileInput &&
    fileInput.current &&
    fileInput.current.files &&
    fileInput.current.files.length > 0
  )

  useEffect(() => {
    if (input.value?.editedImage || input.value?.originalImage) {
      if (fileInput.current) {
        fileInput.current.files = new FileListItems([
          new File([], input.value.editedImage || input.value.originalImage),
        ])
        setShouldRenderRemove(true)
      }
    }
    return () => {
      setOriginalImage(null)
      setShouldRenderRemove(null)
    }
  }, [input.value])


  const reset = () => {
    handleChange({ target: { files: [] } })
    if (onDelete) {
      onDelete()
    }
  }

  const handleChange = ({
    target: {
      files: [file],
    },
  }) => {
    getFileBytes(file)
      .then(bytes => {
        setOriginalImage(bytes)
        setShouldRenderRemove(true)
      })
      .catch(e => {
        setShouldRenderRemove(false)
        setOriginalImage()
        if (input.onChange) {
          input.onChange({})
        }
        if (fileInput && fileInput.current) {
          fileInput.current.value = null
        }
      })
  }

  const handleSave = ({ canvas }) => {
    const editedImage = canvas.toDataURL()
    if (input.onChange) {
      input.onChange({originalImage,editedImage,})
    }

    if (input.onBlur) {
      input.onBlur()
    }
  }

  const disableDownload = () => {
    return false
  }
  return (
    <>
      {label && <label>{label}</label>}
      <InputGroup>
        <Input
          innerRef={fileInput}
          type="file"
          className="form-control"
          accept="image/*"
          onChange={handleChange}
          disabled={disabled}
          
        />
        {shouldRenderRemove && (
          <InputGroupAddon addonType="prepend">
            <Button
              color="danger"
              disabled={disabled}
              type="button"
              onClick={reset}
            >
              Remove
            </Button>
          </InputGroupAddon>
        )}
      </InputGroup>
      {touched && error && <InputError error={error} />}
      <FilerobotImageEditor
        show={!!originalImage}
        src={originalImage}
        onClose={setOriginalImage.bind(null, null)}
        onBeforeComplete={disableDownload}
        onComplete={handleSave}
        config={{
          colorScheme: "light",
          finishButtonLabel: "Save",
        }}
      />
    </>
  )
}

export default ImageEditor
